import React from 'react';
import { Button, Card, CardBody, CardHeader, FormGroup, Input, Label } from 'reactstrap';

interface Props {
  search: string;
  startDate: string;
  endDate: string;
  selectedStatus: string;
  selectedCategory: string;
  onSearchChange: (search: string) => void;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onStatusChange: (status: string) => void;
  onCategoryChange: (category: string) => void;
  onClearFilters: () => void;
}

const PAYMENT_STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'ready_to_pay', label: 'Listo para pagar' },
  { value: 'incomplete_data', label: 'Datos incompletos' },
  { value: 'paid', label: 'Pagado' },
];

const CATEGORY_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'buyer', label: 'Comprador' },
  { value: 'tenant', label: 'Inquilino' },
  { value: 'supply_sales', label: 'Supply Sales' },
  { value: 'supply_rents', label: 'Supply Rents' },
];

const PaymentFilterBar: React.FC<Props> = ({
  search,
  startDate,
  endDate,
  selectedStatus,
  selectedCategory,
  onSearchChange,
  onStartDateChange,
  onEndDateChange,
  onStatusChange,
  onCategoryChange,
  onClearFilters,
}) => {
  return (
    <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '12px' }}>
      <CardHeader
        className="border-0 bg-white py-3 px-4 d-flex justify-content-between align-items-center"
        style={{ borderRadius: '12px 12px 0 0' }}
      >
        <label className="form-control-label mb-0">
          Filtros de Dashboard de Pagos
        </label>
        <Button
          color="secondary"
          outline
          size="sm"
          style={{
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 12,
            padding: '4px 14px',
            boxShadow: 'none',
          }}
          onClick={onClearFilters}
        >
          <i className="fas fa-eraser mr-1" />
          Limpiar filtros
        </Button>
      </CardHeader>

      <CardBody className="pt-0 pb-3 px-4">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: 12,
            background: '#f4f6fa',
            padding: '14px 18px',
            borderRadius: 10,
            fontSize: 13,
          }}
        >
          {/* Buscar */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Buscar
            </Label>
            <Input
              type="text"
              placeholder="Referidor o referido..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            />
          </FormGroup>

          {/* Fecha Inicio */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Fecha desde
            </Label>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            />
          </FormGroup>

          {/* Fecha Fin */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Fecha hasta
            </Label>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            />
          </FormGroup>

          {/* Estado de Pago */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Estado
            </Label>
            <Input
              type="select"
              value={selectedStatus}
              onChange={(e) => onStatusChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            >
              {PAYMENT_STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </FormGroup>

          {/* Categoría */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Categoría
            </Label>
            <Input
              type="select"
              value={selectedCategory}
              onChange={(e) => onCategoryChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            >
              {CATEGORY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        </div>
      </CardBody>
    </Card>
  );
};

export default PaymentFilterBar;
